import React from "react";
import plutonicLogo from "../assets/images/plutonicLogo.svg";
import plutonicName from "../assets/images/plutonicName.svg";

export default function IOSUnsupportedPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#D8F8FF] via-white to-[#eefaff] px-5 py-10">
      <section className="w-full max-w-lg rounded-[2rem] border border-white/80 bg-white/95 p-7 text-center shadow-[0_24px_70px_rgba(24,135,189,0.18)] sm:p-12">
        <div className="mb-8 flex items-center justify-center gap-3">
          <img src={plutonicLogo} alt="" className="h-14 w-20 object-contain sm:h-16 sm:w-24" />
          <img src={plutonicName} alt="Plutonic" className="h-9 w-36 object-contain sm:h-10 sm:w-40" />
        </div>
        <h1 className="text-3xl font-bold text-gray-950 sm:text-4xl">iOS isn’t supported yet</h1>
        <p className="mt-5 text-base leading-relaxed text-gray-600 sm:text-lg">
          Please use an Android, Windows, or macOS device to sign in and join your sessions.
        </p>
      </section>
    </main>
  );
}
